import axios from 'axios';

export const teachingtoolApi = {
    postGetShortUrlToken: (param: API.ShortUrlToken.Req) => {
        return axios.post<API.ShortUrlToken.Res>(
            import.meta.env.VITE_TEACHINGTOOL_API + `/api/token`,
            param
        );
    },

    postGetShortUrl: (param: API.ShortUrl.Req) => {
        return axios.post<API.ShortUrl.Res>(
            import.meta.env.VITE_TEACHINGTOOL_API + `/api/short/add`,
            {
                type: param.type,
                url: param.url,
                startDate: param.startDate,
                endDate: param.endDate,
                userId: param.userId,
            },
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    Authorization: `Bearer ${param.accessToken}`,
                },
            }
        );
    },
};
